import Swal from 'sweetalert2';
import { getAxiosClient } from '~src/api';

export const addFormatToProjectType = async (
  projectTypeDefaultId,
  projectFormatDefaultId
) => {
  const httpClient = await getAxiosClient();

  const data = {
    relations: [
      {
        column: 'default_formats',
        class: 'editor_project_formats_default',
        toIds: [projectFormatDefaultId],
      },
    ],
  };

  let tableName = 'editor_project_types_default';

  try {
    await httpClient.put(
      `${process.env.PARSE_API_URL}/${tableName}/${projectTypeDefaultId}`,
      { data }
    );
  } catch (error) {
    return Swal.fire({
      icon: 'error',
      title: 'Qualcosa &egrave; andato storto',
      html: 'Il salvataggio &egrave; fallito. Si prega di riprovare',
      footer: `Errore: <strong>${error.message}</strong>`,
      confirmButtonColor: '#278e8e',
    });
  }
};
